export default __webpack_public_path__ + "static/media/bell2.00bef04a.wav";